import React from 'react';
import { ResponsiveBubble } from '@nivo/circle-packing';
import theme from '../theme';

const BubbleChart = (props: any) => {
  return (
    <ResponsiveBubble
      root={props.data}
      margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
      identity='name'
      value='count'
      colors={(node: any) => node.color}
      colorBy='name'
      padding={50}
      leavesOnly={true}
      enableLabel={true}
      label={(node: any) => {
        return node.data.score + '/10';
      }}
      labelTextColor={theme.textSecondary}
      borderWidth={30}
      borderColor={{ from: 'color' }}
      animate={true}
      motionStiffness={180}
      motionDamping={25}
    />
  );
};

export default BubbleChart;
